import { render, staticRenderFns } from "./AmEditor.vue?vue&type=template&id=d84fd4c0"
import script from "./AmEditor.vue?vue&type=script&lang=js"
export * from "./AmEditor.vue?vue&type=script&lang=js"
import style0 from "./AmEditor.vue?vue&type=style&index=0&id=d84fd4c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports